(function () {
  if (window.__mpnBuybox) return; window.__mpnBuybox = true;
  var busy = false;
  function vis(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); }
  function topOf(el, c) { while (el && el.parentElement && el.parentElement !== c) el = el.parentElement; return el && el.parentElement === c ? el : null; }
  function before(a, b) { return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING); }
  function priceTop(c) {
    var r = null;
    [].forEach.call(c.children, function (el) {
      if (!r && el.id && el.id.indexOf('variant-price-summary-') === 0 && getComputedStyle(el).display !== 'none') r = el;
    });
    return r;
  }
  function contentBottom(el) {
    var max = null;
    (function walk(n) {
      if (!n || n.nodeType !== 1) return;
      var cs = getComputedStyle(n);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position === 'absolute' || cs.position === 'fixed') return;
      var kids = [].filter.call(n.children, function (k) { return !/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(k.tagName); });
      if (!kids.length || /^(IMG|SVG|BUTTON|INPUT|SELECT|A|LABEL|P|LI)$/i.test(n.tagName)) {
        var r = n.getBoundingClientRect();
        if (r.height > 0 && (max === null || r.bottom > max)) max = r.bottom;
        if (/^(IMG|SVG|BUTTON|INPUT|SELECT)$/i.test(n.tagName)) return;
      }
      kids.forEach(walk);
    })(el);
    return max;
  }
  /* Meme espace entre la fin d'une etape et le titre de la suivante (3,2rem) */
  function equalize(steps, c) {
    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    var want = 3.2 * rem;
    for (var i = 1; i < steps.length; i++) {
      var tp = topOf(steps[i], c); if (!tp) continue;
      var prev = tp.previousElementSibling;
      while (prev && (!vis(prev) || /^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(prev.tagName))) prev = prev.previousElementSibling;
      if (!prev) continue;
      var bottom = contentBottom(prev); if (bottom === null) continue;
      var sp = steps[i].querySelector('.mpn-step') || steps[i];
      var gap = sp.getBoundingClientRect().top - bottom;
      var diff = want - gap;
      if (Math.abs(diff) < 1) continue;
      var cur = parseFloat(getComputedStyle(tp).marginTop) || 0;
      tp.style.setProperty('margin-top', Math.round(cur + diff) + 'px', 'important');
      tp.setAttribute('data-mpn-mt', '1');
    }
  }
  function arrange() {
    var c = document.querySelector('.product__info-container');
    if (!c || busy) return;
    busy = true;
    try {
      /* Fiches a parcours propre : on ne touche pas */
      if (c.querySelector('.mpn-compose, [data-mpn-compose], .mpn-damier, [data-mpn-damier]')) { busy = false; return; }
      var price = priceTop(c);
      var desc = topOf(c.querySelector('.product__text.bottom-border'), c);
      var decl = c.querySelector(':scope > [data-mpn-decl]');
      var fmtStep = c.querySelector('.mpn-fmt__step');
      var fmtTop = fmtStep && vis(fmtStep) ? topOf(fmtStep, c) : null;
      var host = c.querySelector('[data-mpn-dims-host]');
      var qtyLabel = c.querySelector('quantity-calculator .quantity__label');
      var qtyTop = topOf(c.querySelector('quantity-calculator'), c);
      var moved = false;

      /* 1. Ordre : prix -> pictos (carte d'identite du produit) -> accroche -> declinaisons */
      var anchor = price;
      if (anchor && host && host.parentElement === c) {
        if (anchor.nextElementSibling !== host) { anchor.after(host); moved = true; }
        anchor = host;
      }
      if (anchor && desc && desc !== anchor) {
        if (anchor.nextElementSibling !== desc) { anchor.after(desc); moved = true; }
        anchor = desc;
      }
      if (anchor && decl && decl.classList.contains('is-placed')) {
        if (anchor.nextElementSibling !== decl) { anchor.after(decl); moved = true; }
      }

      /* 3. Numeros automatiques (au moins 2 choix) */
      var declTitle = decl && vis(decl) ? decl.querySelector('.mpn-decl__title, .mpn-decl__label') : null;
      /* prix palette : etape « Au m² ou a la palette » entre le format et la quantite (snippets/mpn-palette.liquid) */
      var palBox = c.querySelector(':scope > [data-mpn-pal]');
      var palStep = palBox && !palBox.hidden && vis(palBox) ? palBox.querySelector('.mpn-pal__step') : null;
      var steps = [declTitle, fmtTop ? fmtStep : null, palStep, qtyTop && vis(qtyLabel) ? qtyLabel : null].filter(Boolean);
      c.querySelectorAll('.mpn-in').forEach(function (el) { el.classList.remove('mpn-in'); });
      c.querySelectorAll('.mpn-step-host').forEach(function (el) { el.classList.remove('mpn-step-host'); });
      var oldRail = c.querySelector(':scope > .mpn-rail'); if (oldRail) oldRail.remove();
      if (steps.length >= 2) {
        c.classList.add('mpn-steps-on'); c.classList.remove('mpn-steps-off');
        steps.forEach(function (t, i) {
          var sp = t.querySelector('.mpn-step');
          if (!sp) { sp = document.createElement('span'); sp.className = 'mpn-step'; sp.setAttribute('aria-hidden', 'true'); t.insertBefore(sp, t.firstChild); }
          if (sp.textContent !== String(i + 1)) sp.textContent = String(i + 1);
          t.classList.add('mpn-step-host');
          var tp = topOf(t, c); if (tp) tp.classList.add('mpn-in');
        });
        equalize(steps, c);
      } else {
        c.classList.remove('mpn-steps-on'); c.classList.add('mpn-steps-off');
        c.querySelectorAll('[data-mpn-mt]').forEach(function (el) { el.style.removeProperty('margin-top'); el.removeAttribute('data-mpn-mt'); });
      }
      if (moved) window.dispatchEvent(new Event('resize'));
    } catch (e) {}
    busy = false;
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(arrange, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange); else arrange();
  window.addEventListener('load', function () { setTimeout(arrange, 60); });
  [600, 1400, 2600].forEach(function (ms) { setTimeout(arrange, ms); });
  window.addEventListener('resize', soon);
  document.addEventListener('change', soon, true);
  document.addEventListener('click', function () { setTimeout(arrange, 250); }, true);
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () { if (!busy) soon(); });
    var start = function () { var c = document.querySelector('.product__info-container'); if (c) obs.observe(c, { childList: true }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }
  setInterval(arrange, 1500);
})();
